module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Bold.79a42f06.woff2";